<!-- @veltra/icons generated sha256:8e6c758edd7e1f9c gen:8 source:src/svg/normal/circle-close.svg -->
<script setup lang="ts">
defineOptions({ name: 'CircleClose' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m5.293 0L5.336 9.957a.49.49 0 0 0-.012.698l.008.008a.505.505 0 0 0 .71.001L8 8.707l1.957 1.957a.505.505 0 0 0 .711-.001l.008-.008a.49.49 0 0 0-.012-.698L8.707 8l1.957-1.957a.49.49 0 0 0 .012-.698l-.008-.008a.505.505 0 0 0-.71-.001L8 7.293 6.043 5.336a.49.49 0 0 0-.698-.012l-.008.008a.505.505 0 0 0-.001.71z"
    />
  </svg>
</template>
